var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row justify-content-center mt-md-5" },
    [
      _c("div", { staticClass: "row justify-content-center col-12 col-md-8" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "modal-header-content" }, [
            _c(
              "div",
              {
                staticClass:
                  "ml-md-2 d-flex align-items-end justify-content-end mt-auto"
              },
              [
                _c("img", {
                  staticClass: "step-img",
                  attrs: {
                    src: require("@/assets/images/b122/img-watcher-right.png")
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "container-title" }, [
              _c("h1", { staticClass: "page-title subtitle-step0" }, [
                _vm._v(_vm._s(_vm.$t("annonce.Declare.Title")))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mt-4 mb-3 d-none d-md-flex" }, [
            _c("div", { staticClass: "col-6" }, [
              _c("p", { staticClass: "local-subtitle bold-text" }, [
                _vm._v(_vm._s(_vm.$t("annonce.Declare.Complete.Title")))
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "main-grey-light-color" }, [
                _vm._v(_vm._s(_vm.$t("annonce.Declare.Complete.Doc.Complaint")))
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "main-grey-light-color" }, [
                _vm._v(_vm._s(_vm.$t("annonce.Declare.Complete.Doc.GreyCard")))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6" }, [
              _c("p", { staticClass: "local-subtitle bold-text" }, [
                _vm._v(_vm._s(_vm.$t("annonce.Declare.Partial.Title")))
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "main-grey-light-color" }, [
                _vm._v(_vm._s(_vm.$t("annonce.Declare.Partial.Content")))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row d-none d-md-flex" }, [
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "w-100",
                    attrs: { variant: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.setMaxStep("complete")
                      }
                    }
                  },
                  [_c("div", [_vm._v(_vm._s(_vm.$t("annonce.create.Full")))])]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "w-100",
                    attrs: { variant: "outline-primary" },
                    on: {
                      click: function($event) {
                        return _vm.setMaxStep("fast")
                      }
                    }
                  },
                  [_c("div", [_vm._v(_vm._s(_vm.$t("annonce.create.Fast")))])]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mt-4 mb-3 d-block d-md-none" }, [
            _c(
              "div",
              { staticClass: "col pl-0 pr-0 custom-border-bottom mb-3" },
              [
                _c("p", { staticClass: "local-subtitle bold-text" }, [
                  _vm._v(_vm._s(_vm.$t("annonce.Declare.Complete.Title")))
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "main-grey-light-color" }, [
                  _vm._v(
                    _vm._s(_vm.$t("annonce.Declare.Complete.Doc.Complaint"))
                  )
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "main-grey-light-color" }, [
                  _vm._v(
                    _vm._s(_vm.$t("annonce.Declare.Complete.Doc.GreyCard"))
                  )
                ]),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "mt-2 w-100",
                    attrs: { variant: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.setMaxStep("complete")
                      }
                    }
                  },
                  [_c("div", [_vm._v(_vm._s(_vm.$t("annonce.create.Full")))])]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col pl-0 pr-0" },
              [
                _c("p", { staticClass: "local-subtitle bold-text" }, [
                  _vm._v(_vm._s(_vm.$t("annonce.Declare.Partial.Title")))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "main-grey-light-color" }, [
                  _vm._v(_vm._s(_vm.$t("annonce.Declare.Partial.Content")))
                ]),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "w-100",
                    attrs: { variant: "outline-primary" },
                    on: {
                      click: function($event) {
                        return _vm.setMaxStep("fast")
                      }
                    }
                  },
                  [_c("div", [_vm._v(_vm._s(_vm.$t("annonce.create.Fast")))])]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col mt-5 d-md-none custom-col-12 cursor-pointer",
              on: {
                click: function($event) {
                  return _vm.$bvModal.show("annonce-success-modal")
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "d-flex justify-content-start align-items-center"
                },
                [
                  _c("i", {
                    staticClass: "ph ph-custom ph-question ph-custom-size"
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "page-title custom-span-mobile ml-2" },
                    [_vm._v(_vm._s(_vm.$t("annonce.Declare.Success.Title")))]
                  )
                ]
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "row justify-content-start col-12 col-md-8 mt-4 d-none d-md-block"
        },
        [
          _c("div", { staticClass: "col-12 custom-col-12" }, [
            _c("div", [
              _c("span", { staticClass: "page-title" }, [
                _vm._v(_vm._s(_vm.$t("annonce.Declare.Success.Title")))
              ])
            ]),
            _vm._v(" "),
            _c("p", {
              staticClass: "mt-3 secondary-text-color",
              domProps: {
                innerHTML: _vm._s(_vm.$t("annonce.Declare.Success.Text"))
              }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "row justify-content-start col-12 col-md-8 d-none d-md-flex"
        },
        [
          _c("div", { staticClass: "col-6" }, [
            _c("div", { staticClass: "d-flex align-items-start" }, [
              _c("i", {
                staticClass:
                  "ph-custom ph-check-circle main-color custom-size-icon mt-1"
              }),
              _vm._v(" "),
              _c("p", {
                staticClass: "ml-2 secondary-text-color",
                domProps: {
                  innerHTML: _vm._s(_vm.$t("annonce.Declare.Success.Check"))
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-6" }, [
            _c("div", { staticClass: "d-flex align-items-start" }, [
              _c("i", {
                staticClass:
                  "ph-custom ph-x-circle main-red-color custom-size-icon mt-1"
              }),
              _vm._v(" "),
              _c("p", {
                staticClass: "ml-2 secondary-text-color",
                domProps: {
                  innerHTML: _vm._s(_vm.$t("annonce.Declare.Fail.X"))
                }
              })
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("annonce-success-modal-step0")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64075d1e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64075d1e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/annonce/AnnonceCreate/AnnonceCreateStep0.vue
// module id = Rh8w
// module chunks = 0